
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(760|878)9$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
